import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-folder-icon',
  standalone: true,
  imports: [],
  templateUrl: './folder-icon.component.html',
  styleUrl: './folder-icon.component.css'
})
export class FolderIconComponent {
  @Input() folderColor: string = "#A9BE92";
  @Input() backgroundColor: string = "#D9E5E4";
  
  @Input() width: string = "40";
  @Input() height: string = "41";
}
